import classNames from 'classnames';
import React, { FC, MouseEvent, useMemo, useRef } from 'react';
import { v4 as uuid } from 'uuid';

import { RadioGroupContextProps } from '../RadioGroup.types';
import useRadioGroup from '../useRadioGroup';

import { ControllerProps } from './Controller.types';

import styles from './Controller.module.css';

const Controller: FC<ControllerProps> = ({
  label,
  value,
  controlId,
  control,
  'data-testid': dataTestId = 'radio-group-controller',
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const radioGroup = useRadioGroup();
  const { disabled, onClick, value: groupValue, name } = radioGroup as RadioGroupContextProps;

  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();

    if (inputRef?.current) {
      inputRef?.current.click();
    }
  };

  const controlWithProps = useMemo(() => {
    return React.cloneElement(control, {
      inputRef,
      checked: groupValue === value,
      value,
      name: `${name}_${uuid()}`,
      disabled,
      onClick,
    });
  }, [control, groupValue, disabled, name, onClick, value]);

  return (
    <div className={classNames(styles.option)} data-testid={dataTestId}>
      <div
        className={classNames(styles.labelWrapper)}
        onClick={handleClick}
        aria-hidden="true"
        role="presentation"
      >
        {label && (
          <label className={classNames('bodySBold')} htmlFor={controlId}>
            {label}
          </label>
        )}
      </div>
      <div className={classNames(styles.input)}>{controlWithProps}</div>
    </div>
  );
};

export default Controller;
